<div (click)="gotoTop()" *ngIf="isShow" class="go-to-top vert-move" [ngClass]="{ 'lift-up': isLiftUp }">
  {{ 'lang.commonComponents.commonWords.GotopBtn' | translate }}
</div>
<!-- <div class="go-to-top vert-move" *ngIf="isShow" (click)="gotoTop()">
    <span class="icon-Go-back"></span>
</div> -->
